import { excludeNullOrUndefined } from 'checkout/utils'
import { OFFER_TYPE_BED_BANK, OFFER_TYPE_TOUR } from 'constants/offer'
import { isCruiseOffer, isTourV2Offer, isCruiseV1Offer } from 'lib/offer/offerTypes'
import type { IntlShape } from 'react-intl'

export function getLocationString(
  intl: IntlShape,
  offer: App.Offer | App.OfferSummary | App.BedbankOffer | App.Tours.TourV2Offer | App.CruiseOffer,
  variationId?: string,
): string {
  if (!offer) return ''

  if (isTourV2Offer(offer)) {
    const variations = Object.values(offer.variations)
    if (variations.length === 0) return ''

    const variation = (!!variationId && offer?.variations[variationId]) || variations[0]

    return variation.startLocation === variation.endLocation ?
        intl.formatMessage(
          { id: '9YpFaP0mli', defaultMessage: 'Starts and ends in {location}', description: 'Tour location label when start and end locations are the same' },
          { location: variation.startLocation },
        ) :
        intl.formatMessage(
          { id: 'y71oeIPgEI', defaultMessage: 'Starts in {startLocation}, Ends in {endLocation}', description: 'Tour location label when start and end locations differ' },
          { startLocation: variation.startLocation, endLocation: variation.endLocation },
        )
  }

  if (offer.type === OFFER_TYPE_BED_BANK) {
    return offer.property.location
  }

  if (isCruiseOffer(offer) || isCruiseV1Offer(offer)) {
    const departureCity = isCruiseOffer(offer) ? offer.departurePort.split(',')[0] : offer.startLocation?.split(',')?.[0]
    const destinationCity = isCruiseOffer(offer) ? offer.returnPort.split(',')[0] : offer.endLocation?.split(',')?.[0]
    return departureCity === destinationCity ?
        intl.formatMessage(
          { id: '7c8+A2yQaT', defaultMessage: 'Starts and ends in {location}', description: 'Cruise location label when departure and return ports are the same' },
          { location: departureCity },
        ) :
        intl.formatMessage(
          { id: 'PughG7a1PC', defaultMessage: 'Starts in {startLocation}, Ends in {endLocation}', description: 'Cruise location label when departure and return ports differ' },
          { startLocation: departureCity, endLocation: destinationCity },
        )
  }

  if (offer.type === OFFER_TYPE_TOUR) {
    return offer.location
  }

  else {
    return [offer.locationHeading, offer.locationSubheading].filter(excludeNullOrUndefined).join(', ')
  }
}
